import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import cx from 'classnames';
import { openTaskCreationModal } from '../TaskCreationModal';

export function CreateNewGreetButton() {
  const onButtonClick = () => openTaskCreationModal();

  return (
    <div
      onClick={onButtonClick}
      className={cx([
        'v2-group v2-bg-yellow-100 hover:v2-bg-yellow-500 flex flex-row h-[70px]',
        'items-center v2-text-neutral-900 cursor-pointer z-40 px-5 py-3.5 gap-x-4',
        'select-none',
      ])}
    >
      <div
        className={cx([
          'v2-bg-yellow-500 group-hover:v2-bg-yellow-200 rounded-full',
          'p-5 flex items-center justify-center transition-transform',
          'duration-400 transform group-hover:v2-rotate-180 w-12 h-12',
        ])}
      >
        <FontAwesomeIcon className='text-lg' icon={faPlus} />
      </div>
      <div className='flex flex-col'>
        <span className='text-base font-bold'>Send a new message</span>
        <span className='text-xs'>Add new contact or upload CSV</span>
      </div>
    </div>
  );
}
